import styled from "styled-components/macro";

export const Footer = styled.footer(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  paddingTop: 30,
  paddingBottom: 50,

  [theme.breakpoint.xl()]: {
    paddingTop: 30,
    paddingBottom: 30,
    flexDirection: "row",
    alignItems: "center",
  },
}));
